import React from "react";
import { X } from "lucide-react";
import { colorForIndex } from "../utils/colors";
import { areaUniquenessKey, uniqueAreas } from "../utils/areas";

const AreaChipList = ({ areas, selectedAreaId, onSelect, onRemove }) => {
  const visibleAreas = uniqueAreas(areas);

  if (!visibleAreas.length) {
    return (
      <p className='text-sm text-primaryAsh'>
        No areas yet — use Draw Area or Search to add one.
      </p>
    );
  }

  return (
    <div className='flex flex-col gap-2'>
      {visibleAreas.map((area, index) => {
        const areaId = String(area.id);
        const areaKey = areaUniquenessKey(area) || areaId;

        return (
          <div
            key={areaKey}
            onClick={() => onSelect(areaId)}
            className={`flex items-center justify-between border rounded-lg px-3 py-2 cursor-pointer ${
              selectedAreaId === areaId
                ? "border-primaryGreen bg-bgGreen"
                : "border-lightGray"
            }`}
          >
            <div className='flex items-center gap-2'>
              <span
                className='w-2.5 h-2.5 rounded-full flex-shrink-0'
                style={{ background: colorForIndex(index) }}
              />
              <span className='text-sm text-primaryBlack'>{area.name}</span>
            </div>
            <button
              type='button'
              aria-label={`Remove ${area.name}`}
              onClick={(e) => {
                e.stopPropagation();
                onRemove(areaId);
              }}
              className='w-5 h-5 rounded flex items-center justify-center text-primaryAsh hover:bg-lightGray'
            >
              <X size={11} />
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default AreaChipList;
